<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <table-search
        :style="{ float: 'right' }"
        @onSearch="onSearch"
        @onSearchUser="onSearchUser"
        @onStartTime="onStartTime"
        @onEndTime="onEndTime"
        @onSearchCompany="onSearchCompany"
        @onExport="onExport"
      />
    </div>

    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
        <template
          slot="info"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => handleAnswer(record)"
          >点击查看</a>
        </template>
      </a-table>
    </div>
    <answer-modal
      :feedback-data="answerData"
      :visible="answerVisible"
      @onCancel="cancelAnswer"
    />
  </div>
</template>
<script>
import { columns } from './data/index';
import TableSearch from './components/search.vue';
import answerModal from './modal/index';
export default {
  components: { TableSearch, answerModal },
  data() {
    return {
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      btnIsLoading: false,
      visible: false,
      id: '',
      answerData: {before_list: [], after_list: []},
      answerVisible: false,
      start_time: '',
      end_time: '',
      drug_id: '',
      username: '',
      token: '',
      keyword: '',
    };
  },
  mounted() {
    this.token=localStorage.getItem('token');
    // 获取表格数据
    this.getTableData({
      page: this.current,
      pageSize: this.pageSize,
      keyword: this.keyword,
      username: this.username,
      start_time: this.start_time,
      end_time: this.end_time,
    });
  },
  methods: {
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post('/portalAnswer/getAnswerList', params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.create_time,
            name: item.name,
            company_name: item.company_name,
            user_realname: item.user_realname
              ? item.user_realname
              : item.user_nickname,
            create_time: this.$Format(item.create_time),
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;
      }
    },
    // 查看反馈
    handleAnswer(record) {
      console.log('handleAnswer -> record', record);
      this.answerVisible = true;
      this.answerData =
        {
          before_list: record.data.before_list,
          after_list: record.data.after_list,
        };
      console.log('this.answerData', this.answerData);
    },
    // 取消查看
    cancelAnswer() {
      this.answerVisible = false;
    },
    // 导出
    onExport() {
      if (this.drug_id) {
        window.location.href=`${this.uploadUrl}/portalAnswer/exportResult?company_id=${this.drug_id}
       &start_time=${this.start_time}&end_time=${this.end_time}
       &username=${this.username}&token=${this.token}&keyword=${this.keyword}`;
      }else{
        this.$message.warning('请选择企业！');
      }
    },
    // 企业搜索
    onSearchCompany(value) {
      this.current = 1;
      this.drug_id = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        username: this.username,
        start_time: this.start_time,
        end_time: this.end_time,
        company_id: this.drug_id,
        keyword: this.keyword,
      });
    },
    // 时间搜索
    onStartTime(value) {
      this.current = 1;
      this.start_time = this.$Date(value);
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        username: this.username,
        start_time: this.start_time,
        end_time: this.end_time,
        company_id: this.drug_id,
        keyword: this.keyword,
      });
    },
    onEndTime(value) {
      this.current = 1;
      this.end_time = this.$Date(value);
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        username: this.username,
        start_time: this.start_time,
        end_time: this.end_time,
        company_id: this.drug_id,
        keyword: this.keyword,
      });
    },
    // 搜索
    onSearch(value) {
      this.current = 1;
      this.keyword = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        username: this.username,
        start_time: this.start_time,
        end_time: this.end_time,
        company_id: this.drug_id,
        keyword: this.keyword,
      });
    },
    // 用户搜索
    onSearchUser(value) {
      this.current = 1;
      this.username = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        username: this.username,
        start_time: this.start_time,
        end_time: this.end_time,
        company_id: this.drug_id,
        keyword: this.keyword,
      });
    },
    // 分页
    changePage(pagination) {
      this.current = pagination.current;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        username: this.username,
        start_time: this.start_time,
        end_time: this.end_time,
        company_id: this.drug_id,
        keyword: this.keyword,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
}
</style>
